import * as React from 'react';
import * as sub from "./sub.module.scss";
import { TaxDeduction } from "../../../../../TaxDeduction";
export const CostSub = ({ data, widget, isTrial=false }) => {
  return (
    <section className={sub.sub} id="user-action">
      <div className="container">
        <div className={sub.sub__inner}>
          <div className={sub.sub__description}>
            <h2 className={sub.sub__title}>
              {
                !isTrial ?
                  "Доступ на\u00A01\u00A0месяц"
                  :
                  "Учись\u00A0Учиться для\u00A0школьников"
              }
            </h2>
            <div>
              <ul className={sub.sub__itemList}>
                {
                  data.map((elem) => (
                    <li>{elem.clientGets}</li>
                  ))
                }
              </ul>
              {
                isTrial ?
                  (<div className={sub.trial}>
                    <p className={sub.trial__txt}>3-дневный пробный период</p>
                    <p className={sub.trial__cost}>за 1 ₽</p>
                  </div>)
                  :
                  (<div className={sub.newcost}>4 999 ₽<span className={sub.month}>/месяц</span></div>)
              }
            </div>
            <TaxDeduction margin={"30px 0 0"}/>
          </div>
          <div className={sub.sub__widget}>
            {widget}
          </div>
        </div>
      </div>
    </section>
  );
}
